module.exports = __webpack_public_path__ + "static/media/08.399f6a21.png";